import React, { useState } from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../siteConfig";
import { submitLead } from "../submitLead";

const QuoteFormEmbed = ({ title = "Get Your Free Quote" }) => {
  // ─── GHL EMBED ───────────────────────────────────────────
  // When you have the GoHighLevel embed code, replace this
  // entire component body with:
  //
  //   if (siteConfig.ghlFormEmbed) {
  //     return <div dangerouslySetInnerHTML={{ __html: siteConfig.ghlFormEmbed }} />;
  //   }
  // ─────────────────────────────────────────────────────────

  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    // Forgiving UX: always thank the visitor; delivery failures are logged.
    await submitLead(form);
    setSubmitting(false);
    setSubmitted(true);
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10 w-full">
      <h3
        className="font-display font-black text-2xl mb-1"
        style={{ color: siteConfig.colors.dark }}
      >
        {title}
      </h3>
      <p className="text-sm font-medium text-gray-600 mb-6">
        Free estimate • No obligation • Responds within 24 hrs
      </p>

      {submitted ? (
        <div className="py-10 text-center">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
            style={{ backgroundColor: `${siteConfig.colors.primary}18` }}
          >
            <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" style={{ color: siteConfig.colors.primary }}>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <p className="font-display font-black text-lg mb-1" style={{ color: siteConfig.colors.dark }}>
            We got it!
          </p>
          <p className="text-sm text-gray-600">We'll be in touch shortly.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">

          {/* Full Name */}
          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1.5">
              Full Name <span style={{ color: siteConfig.colors.primary }}>*</span>
            </label>
            <input
              type="text"
              required
              placeholder="John Smith"
              value={form.name}
              onChange={(e) => set("name", e.target.value)}
              className="w-full h-12 px-4 bg-gray-100 rounded-xl border border-gray-300 text-base text-gray-900 placeholder-gray-400 outline-none focus:border-current transition-colors"
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1.5">Phone</label>
            <div className="flex items-center h-12 bg-gray-100 rounded-xl border border-gray-300 overflow-hidden">
              <div className="flex items-center gap-1 pl-4 pr-3 border-r border-gray-300 shrink-0">
                <span className="text-lg leading-none">🇺🇸</span>
                <span className="text-gray-500 text-xs">▾</span>
              </div>
              <input
                type="tel"
                placeholder="(555) 555-5555"
                value={form.phone}
                onChange={(e) => set("phone", e.target.value)}
                className="flex-1 h-full px-4 text-base text-gray-900 placeholder-gray-400 outline-none bg-transparent"
              />
            </div>
          </div>

          {/* Short Message */}
          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1.5">
              Short message about your needs <span style={{ color: siteConfig.colors.primary }}>*</span>
            </label>
            <textarea
              required
              rows={5}
              placeholder="Tell us a bit about your project..."
              value={form.message}
              onChange={(e) => set("message", e.target.value)}
              className="w-full px-4 py-3 bg-gray-100 rounded-xl border border-gray-300 text-base text-gray-900 placeholder-gray-400 outline-none resize-none"
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={submitting}
            className="w-full h-14 rounded-xl font-black text-white text-base tracking-wide transition-opacity hover:opacity-90 disabled:opacity-60"
            style={{ backgroundColor: siteConfig.colors.primary }}
          >
            {submitting ? "Sending…" : "Send My Free Quote Request →"}
          </button>

          {/* Disclaimer */}
          <p className="text-xs text-gray-500 leading-relaxed">
            By submitting this form I agree to{" "}
            <Link to="/terms" className="underline font-semibold" style={{ color: siteConfig.colors.primary }}>
              terms &amp; conditions
            </Link>{" "}
            provided by {siteConfig.businessName}. By providing my phone number, I
            agree to receive text messages from {siteConfig.businessName}.
          </p>
        </form>
      )}
    </div>
  );
};

export default QuoteFormEmbed;
